import Loader from './loader.jsx';
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBInput,
} from 'mdb-react-ui-kit';
import { isDateInFuture } from '../utils.js';
import { useState } from 'react';

export default function StartVotingPopUp(props){
    const{ show, setShow } = props;

    // Only allow future dates: set minimum to tomorrow
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const minDate = tomorrow.toLocaleDateString("sv-SE"); // Format as YYYY-MM-DD

    const [ votingDeadline , setVotingDeadline ] = useState(minDate);

    function handleStartVotingPeriodACB(){
        if( isDateInFuture(votingDeadline) ){ 
            props.onStartVotingPeriod(votingDeadline);
            setShow(false);
        }
        else{
            alert("Please select a valid future date for the voting deadline.");
        }
    }
    return <MDBModal open={show} setOpen={setShow} tabIndex="-1">
        <MDBModalDialog centered={true} size="md"> 
            <MDBModalContent className="p-4 rounded-lg shadow-lg">
                <MDBModalHeader>
                    <MDBModalTitle className="font-semibold text-xl">Voting Period</MDBModalTitle>
                </MDBModalHeader>

                <MDBModalBody className="space-y-4 mt-4">
                    <div className="flex flex-col items-center">
                        <p className="text-amber-700 mb-4 text-center">
                            Set a deadline for the voting period. Members will be able to suggest books and vote until this date.
                        </p>
                        <MDBInput
                            type="date"
                            value={votingDeadline}
                            min={minDate}
                            onChange={(e) => setVotingDeadline(e.target.value)}
                        />
                    </div>
                </MDBModalBody>

                <MDBModalFooter className="flex gap-2 justify-end mt-6">
                        <button
                            onClick={() => setShow(false)}
                            className="px-4 py-2 border border-blue-200 text-blue-700 !rounded-lg hover:bg-blue-50 transition-colors"
                        >
                        Cancel
                        </button>
                        <button
                            onClick={handleStartVotingPeriodACB}
                            className="px-6 py-2 bg-gradient-to-r from-blue-500 to-cyan-600 text-white !rounded-lg hover:from-blue-600 hover:to-cyan-700 transition-all"
                        >
                        Start Voting Period
                        </button>   
                </MDBModalFooter>
            </MDBModalContent>
        </MDBModalDialog>
    </MDBModal>
}